(function () {
  var root = document.documentElement;

  var desktopMq = window.matchMedia('(min-width: 750px)');
  var WIDTHS = { phone: [420, 639], 'cord-back': [640], 'cord-front': [640] };

  function unit() {
    var w = window.innerWidth;
    return desktopMq.matches ? Math.min(w, 1600) / 1440 : Math.min(w, 560) / 402;
  }

  function init(section) {
    var artEl = section.querySelector('[data-hev-behold-art]');
    var art = {};
    try {
      art = JSON.parse(artEl.textContent);
    } catch (e) {}

    var layers = {};
    section.querySelectorAll('[data-hev-art]').forEach(function (img) {
      layers[img.getAttribute('data-hev-art')] = img;
    });
    var swatches = Array.prototype.slice.call(section.querySelectorAll('[data-hev-swatch]'));
    var current = section.getAttribute('data-color') || 'aquamarine';
    var warmed = {};

    function srcsetFor(layer, urls) {
      return urls.map(function (u, i) { return u + ' ' + WIDTHS[layer][i] + 'w'; }).join(', ');
    }

    /* Load the size the browser is already showing for each layer, so the swap
       is instant and never flashes an empty frame. */
    function warm(color) {
      if (warmed[color]) return warmed[color];
      var entry = art[color];
      if (!entry) return Promise.resolve();
      var jobs = Object.keys(layers).map(function (layer) {
        var img = layers[layer];
        var urls = entry[layer];
        if (!urls) return Promise.resolve();
        var shown = img.currentSrc || img.src;
        var large = !/-420\.webp/.test(shown);
        var probe = new Image();
        probe.decoding = 'async';
        probe.src = urls[large ? urls.length - 1 : 0];
        return probe.decode ? probe.decode().catch(function () {}) : Promise.resolve();
      });
      warmed[color] = Promise.all(jobs);
      return warmed[color];
    }

    function apply(color) {
      var entry = art[color];
      if (!entry) return;
      Object.keys(layers).forEach(function (layer) {
        var img = layers[layer];
        var urls = entry[layer];
        if (!urls) return;
        if (urls.length > 1) img.srcset = srcsetFor(layer, urls);
        img.src = urls[0];
        if (layer === 'phone') img.alt = entry.label;
      });
      current = color;
      section.setAttribute('data-color', color);
      root.setAttribute('data-hev-color', color);
      swatches.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-hev-swatch') === color ? 'true' : 'false');
      });
      document.dispatchEvent(new CustomEvent('hev:colorchange', { detail: { color: color, variantId: entry.variantId } }));
    }

    function pick(color) {
      if (color === current) return;
      var timeout = new Promise(function (resolve) { setTimeout(resolve, 600); });
      Promise.race([warm(color), timeout]).then(function () { apply(color); });
    }

    swatches.forEach(function (b) {
      var color = b.getAttribute('data-hev-swatch');
      ['pointerenter', 'pointerdown', 'focus'].forEach(function (type) {
        b.addEventListener(type, function () { warm(color); }, { passive: true });
      });
      b.addEventListener('click', function () { pick(color); });
    });

    root.setAttribute('data-hev-color', current);

    /* ---- Callouts: one shared box and leader line ------------------------ */

    var box = section.querySelector('[data-hev-callout]');
    var titleEl = section.querySelector('[data-hev-callout-title]');
    var bodyEl = section.querySelector('[data-hev-callout-body]');
    var leader = section.querySelector('[data-hev-leader]');
    var taps = Array.prototype.slice.call(section.querySelectorAll('[data-hev-tap]'));
    var dots = taps.map(function (t) { return t.querySelector('.hev-tap__dot'); }).filter(Boolean);
    var active = null;
    var pinned = false;
    var refocusing = false;
    var hideT = null;
    var swapT = null;
    var settleT = null;
    var OUT_MS = 140;

    /* Hidden by opacity/visibility from here on, so they can animate. */
    box.hidden = false;
    leader.hidden = false;

    function place(tap) {
      var s = section.getBoundingClientRect();
      var r = tap.getBoundingClientRect();
      var cx = r.left + r.width / 2 - s.left;
      var cy = r.top + r.height / 2 - s.top;
      var d = desktopMq.matches;
      var u = unit();
      var anchor = tap.getAttribute(d ? 'data-anchor-d' : 'data-anchor-m');
      var gx = parseFloat(tap.getAttribute(d ? 'data-gx-d' : 'data-gx-m')) * u;
      var gy = parseFloat(tap.getAttribute(d ? 'data-gy-d' : 'data-gy-m')) * u;
      var lx = parseFloat(tap.getAttribute(d ? 'data-lx-d' : 'data-lx-m'));
      var right = anchor.charAt(1) === 'r';
      var below = anchor.charAt(0) === 't';
      var margin = d ? 24 : 16;
      var bw = box.offsetWidth;
      var bh = box.offsetHeight;

      var left = cx - gx - (right ? bw : 0);
      var top = cy - gy - (below ? 0 : bh);
      left = Math.max(margin, Math.min(left, s.width - bw - margin));
      top = Math.max(margin, Math.min(top, s.height - bh - margin));
      box.style.translate = left + 'px ' + top + 'px';

      var kx = left + bw * (isNaN(lx) ? (right ? 1 : 0) : lx);
      var ky = below ? top : top + bh;
      box.style.setProperty('--ox', ((kx - left) / bw) * 100 + '%');
      box.style.setProperty('--oy', below ? '0%' : '100%');

      /* Runs from just inside the open dot's black ring (so it reads as behind
         the dot) out to the callout. */
      var dx = kx - cx;
      var dy = ky - cy;
      var len = Math.hypot(dx, dy) || 1;
      var dot = tap.querySelector('.hev-tap__dot');
      var grow = parseFloat(getComputedStyle(section).getPropertyValue('--tap-on')) || 1;
      var stop = dot ? (dot.offsetWidth / 2) * grow * 0.85 : 0;
      leader.style.width = Math.max(0, len - stop) + 'px';
      leader.style.translate = cx + (dx / len) * stop + 'px ' + (cy + (dy / len) * stop - 1.5) + 'px';
      leader.style.rotate = Math.atan2(dy, dx) + 'rad';
    }

    /* Swap the dots' state without a jump: freeze each at its current pulse
       scale, then let the new state transition from there. */
    function setActiveDot(tap) {
      dots.forEach(function (d) {
        var scale = new DOMMatrix(getComputedStyle(d).transform).a || 1;
        d.style.animation = 'none';
        d.style.transform = 'scale(' + scale + ')';
      });
      void section.offsetWidth;
      clearTimeout(settleT);
      section.classList.toggle('has-active', !!tap);
      section.classList.toggle('is-settling', !tap);
      if (!tap) settleT = setTimeout(function () { section.classList.remove('is-settling'); }, 240);
      taps.forEach(function (t) {
        var on = t === tap;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      dots.forEach(function (d) {
        d.style.animation = '';
        d.style.transform = '';
      });
    }

    function render(tap) {
      titleEl.textContent = tap.getAttribute('data-title');
      bodyEl.textContent = tap.getAttribute('data-body');
      place(tap);
      box.classList.add('is-visible');
      leader.classList.add('is-visible');
    }

    function open(tap, pin) {
      clearTimeout(hideT);
      pinned = !!pin;
      /* Already opening (e.g. the focus that precedes a tap's click): leave any
         pending swap to finish. */
      if (active === tap) return;
      clearTimeout(swapT);
      var swapping = active && box.classList.contains('is-visible');
      active = tap;
      setActiveDot(tap);
      if (swapping) {
        /* Let the old callout leave before the new one arrives. */
        box.classList.remove('is-visible');
        leader.classList.remove('is-visible');
        swapT = setTimeout(function () { render(tap); }, OUT_MS);
      } else {
        render(tap);
      }
    }

    function close(soon) {
      if (!active) return;
      clearTimeout(hideT);
      function go() {
        clearTimeout(swapT);
        active = null;
        pinned = false;
        box.classList.remove('is-visible');
        leader.classList.remove('is-visible');
        setActiveDot(null);
      }
      /* A short grace period, so brushing past a dot's edge doesn't flicker. */
      if (soon) hideT = setTimeout(go, 70);
      else go();
    }

    taps.forEach(function (tap) {
      tap.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse' && !pinned) open(tap, false);
      });
      tap.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse' && !pinned && active === tap) close(true);
      });
      tap.addEventListener('focus', function () {
        if (!refocusing && active !== tap) open(tap, false);
      });
      tap.addEventListener('blur', function () {
        if (!pinned && active === tap) close();
      });
      tap.addEventListener('click', function (e) {
        e.stopPropagation();
        if (active === tap && pinned) close();
        else open(tap, true);
      });
    });

    document.addEventListener('click', function (e) {
      if (active && !box.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !active) return;
      var tap = active;
      close();
      refocusing = true;
      tap.focus({ preventScroll: true });
      refocusing = false;
    });

    window.addEventListener('resize', function () {
      if (active) place(active);
    });
  }

  function boot() {
    document.querySelectorAll('[data-hev-behold]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
